import React, { Component } from 'react'
import { TweenMax, TimelineMax, Power1, Power4 } from 'gsap'
import * as ScrollMagic from 'scrollmagic'
// import ScrollMagic from 'scrollmagic'
// import 'animation.gsap'

// Components
import BotonMenu from './../menus/BotonMenu'
import Menu from './../menus/Menu'
import MenuSec from './../menus/MenuSec'

// Images
import ilogo from "./../../assets/img/logo-tanta.svg";
import ifondo1 from "./../../assets/img/1.svg";
import ifondo2 from "./../../assets/img/2.svg";
import ifondo3 from "./../../assets/img/3.svg";
import ifondo4 from "./../../assets/img/4.svg";
import ifondo5 from "./../../assets/img/5.svg";
import ifondo6 from "./../../assets/img/6.svg";
import ifondo7 from "./../../assets/img/7.svg";
import teteraC from "./../../assets/img/tetera-color.svg";
import naranjaC from "./../../assets/img/naranja-color.svg";
import pinaC from "./../../assets/img/pina-color.svg";
import pimientoC from "./../../assets/img/pimiento-color.svg";

// const ScrollMagic = require('scrollmagic')

class Intro extends Component {
  constructor(props) {
    super(props);
    this.activeMenu = this.activeMenu.bind(this);
    this.state = {
      isActive: false,
    }
  }

  activeMenu() {
    this.setState((prevState) => {
      return {
        isActive: !prevState.isActive
      }
    })
  }

  intro() {
    if (typeof window.orientation === 'undefined' || window.innerWidth >= 768) {
      // Animación Intro - imagenes
      const logo = document.querySelector('.logo-tanta');
      const fondo1 = document.querySelector('.fondo1');
      const fondo2 = document.querySelector('.fondo2');
      const fondo3 = document.querySelector('.fondo3');
      const fondo4 = document.querySelector('.fondo4');
      const fondo5 = document.querySelector('.fondo5');
      const fondo6 = document.querySelector('.fondo6');
      const fondo7 = document.querySelector('.fondo7');
      const tetera = document.querySelector('.tetera-c');
      const naranja = document.querySelector('.naranja-c');
      const pina = document.querySelector('.pina-c');
      const pimiento = document.querySelector('.pimiento-c');
      const menu = document.querySelector(".button-menu");

      // Timeline animacion Intro
      const tlInitial = new TimelineMax({ delay: 0.4, repeat: 0 });

      tlInitial
        .set([logo, fondo1, fondo2, fondo3, fondo4, fondo5, fondo6, fondo7, tetera, naranja, pina, pimiento], { opacity: 0 })
        .fromTo(fondo1, 0.6, { autoAlpha: 0, xPercent: '-30' }, {autoAlpha: 1, xPercent: '0', ease: Power4.easeInOut})
        .fromTo(fondo4, 1, { autoAlpha: 0, yPercent: '-30' }, { autoAlpha: 1, yPercent: '0', ease: Power4.easeInOut}, '-=0.75')
        .fromTo(fondo7, 1, { autoAlpha: 0, xPercent: '30' }, { autoAlpha: 1, xPercent: '0', ease: Power4.easeInOut}, '-=0.75')
        .fromTo(fondo3, 1, { autoAlpha: 0, yPercent: '-30' }, { autoAlpha: 1, yPercent: '0', ease: Power4.easeInOut}, '-=0.85')
        .fromTo(fondo2, 1, { autoAlpha: 0, xPercent: '-20' }, { autoAlpha: 1, xPercent: '0', ease: Power4.easeInOut}, '-=0.75')
        .fromTo(fondo5, 1, { autoAlpha: 0, yPercent: '-30' }, { autoAlpha: 1, yPercent: '0', ease: Power4.easeInOut}, '-=0.75')
        .fromTo(fondo6, 1, { autoAlpha: 0, xPercent: '30' }, { autoAlpha: 1, xPercent: '0', ease: Power4.easeInOut}, '-=0.8')
        .fromTo(logo, 0.8, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeInOut }, '-=0.1')
        .fromTo(menu, 0.6, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeInOut }, '-=0.1')
        .add('IconsStart')
        .fromTo(tetera, 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeInOut }, '-=0.1')
        .fromTo(pina, 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeInOut }, '-=0.2')
        .fromTo(naranja, 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeInOut }, '-=0.2')
        .fromTo(pimiento, 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power4.easeInOut }, '-=0.2')

      //ScrollMagic
      // const controller = new ScrollMagic.Controller();

      // const tween1 = TweenMax.to(fondo1, 1, { x: '-220px', ease: Power1.easeOut });
      // const tween2 = TweenMax.to(fondo2, 1, { x: '-180px', ease: Power1.easeOut });
      // const tween3 = TweenMax.to(fondo3, 2, { y: '-160px', ease: Power1.easeOut });
      // const tween4 = TweenMax.to(fondo4, 2, { y: '-40px', ease: Power1.easeOut });
      // const tween5 = TweenMax.to(fondo5, 1, { y: '-50px', ease: Power1.easeOut });
      // const tween6 = TweenMax.to(fondo6, 1, { x: '100px', ease: Power1.easeOut });
      // const tween7 = TweenMax.to(fondo7, 1, { x: '160px', ease: Power1.easeOut });
      // const tweenNaranja = TweenMax.to(naranja, 2, { x: '-20px', y: '-60px', ease: Power1.easeOut });
      // const tweenTetera = TweenMax.to(tetera, 2, { x: '-100px', y: '220px', ease: Power1.easeOut });
      // const tweenPina = TweenMax.to(pina, 2, { x: '60px', y: '-120px', ease: Power1.easeOut });
      // const tweenPimiento = TweenMax.to(pimiento, 2.5, { x: '100px', y: '140px', ease: Power1.easeOut });

      // new ScrollMagic.Scene({
      //   triggerElement: fondo1,
      //   duration: 380,
      //   offset: -145
      // })
      // .setTween(tween1).addTo(controller);

    //   const  scene2 = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 300,
    //     offset: -145
    //   })
    //   .setTween(tween2).addTo(controller);

    //   const scene3 = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 330,
    //     offset: -145
    //   })
    //   .setTween(tween3).addTo(controller);

    //   const scene4 = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 350,
    //     offset: -145
    //   })
    //     .setTween(tween4).addTo(controller);

    //   const scene5 = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 200,
    //     offset: -145
    //   })
    //     .setTween(tween5).addTo(controller);

    //   const scene6 = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 360,
    //     offset: -145
    //   })
    //     .setTween(tween6).addTo(controller);

    //   const scene7 = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 380,
    //     offset: -145
    //   })
    //     .setTween(tween7).addTo(controller);

    //   const sceneNaranja = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 300,
    //     offset: -145
    //   })
    //     .setTween(tweenNaranja).addTo(controller);

    //  const sceneTetera = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 840,
    //     offset: -145
    //   })
    //     .setTween(tweenTetera).addTo(controller);

    //   const scenePina = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 840,
    //     offset: -145
    //   })
    //     .setTween(tweenPina).addTo(controller);

    //   const scenePimiento = new ScrollMagic.Scene({
    //     triggerElement: fondo1,
    //     duration: 780,
    //     offset: -145
    //   })
    //     .setTween(tweenPimiento).addTo(controller);
    }
  }

  componentDidMount() {
    this.intro();
  }

  render() {
    return (
      <section name="#inicio" id="inicio" className="hero is-fullheight intro">
        <BotonMenu activeMenu={this.activeMenu} isActive={this.state.isActive} />
        <Menu activeMenu={this.activeMenu} isActive={this.state.isActive} lang={this.props.lang} />
        <MenuSec isActive={this.state.isActive} lang={this.props.lang} />

        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title">
              <img className="logo-tanta" src={ilogo} alt="Tanta" />
            </h1>
          </div>
        </div>

        <img className="fondo1" src={ifondo1} alt="" />
        <img className="fondo2" src={ifondo2} alt="" />
        <img className="fondo3" src={ifondo3} alt="" />
        <img className="fondo4" src={ifondo4} alt="" />
        <img className="fondo5" src={ifondo5} alt="" />
        <img className="fondo6" src={ifondo6} alt="" />
        <img className="fondo7" src={ifondo7} alt="" />
        <img className="tetera-c" src={teteraC} alt="" />
        <img className="naranja-c" src={naranjaC} alt="" />
        <img className="pina-c" src={pinaC} alt="" />
        <img className="pimiento-c" src={pimientoC} alt="" />
      </section>
    )
  }
}

export default Intro;
